export const activateOnEnterOrSpace = (event) => {
  if (event.key !== "Enter" && event.key !== " ") return;

  event.preventDefault();
  event.currentTarget.click();
};
